import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { Phone, MessageCircle } from 'lucide-react'
import { settingsService } from '../services/api'

const ContactButtons = ({ product }) => {
  const { data: settings } = useQuery({
    queryKey: ['storeSettings'],
    queryFn: settingsService.getSettings,
    retry: false,
  })

  if (!settings || (!settings.phone_number && !settings.whatsapp_number)) {
    return null
  }

  const handleCall = () => {
    if (settings.phone_number) {
      window.location.href = `tel:${settings.phone_number}`
    }
  }

  const handleWhatsApp = () => {
    if (settings.whatsapp_number) {
      const message = `Hi, I'm interested in ${product.name} - ${window.location.href}`
      const whatsappUrl = `https://wa.me/${settings.whatsapp_number.replace(/[^\d]/g, '')}?text=${encodeURIComponent(message)}`
      window.open(whatsappUrl, '_blank')
    }
  }

  return (
    <div className="flex space-x-4 mb-6">
      {settings.phone_number && (
        <button
          onClick={handleCall}
          className="flex-1 btn btn-outline btn-lg flex items-center justify-center space-x-2"
        >
          <Phone className="h-5 w-5" />
          <span>Call Now</span>
        </button>
      )}
      {settings.whatsapp_number && (
        <button
          onClick={handleWhatsApp}
          className="flex-1 btn btn-lg flex items-center justify-center space-x-2"
          style={{ backgroundColor: '#122620', color: 'white' }}
        >
          <MessageCircle className="h-5 w-5" />
          <span>WhatsApp</span>
        </button>
      )}
    </div>
  )
}

export default ContactButtons
